/**
 * The five ad platforms this app can connect, and what each one's connect form
 * needs. Data — and shared, which is why it is here: the Settings page renders
 * it and usePlatformAccounts looks accounts up in it.
 */

import type { PlatformConfig } from '@/types';

export const AVAILABLE_PLATFORMS: PlatformConfig[] = [
  {
    type: "facebook",
    name: "facebook",
    displayName: "Facebook Ads",
    icon: "📘",
    description: "Connect your Facebook Ads account to track campaign performance",
    requiresAuth: true,
    authType: "oauth2",
    connectionMethods: ["token", "oauth2"],
    scopes: ["ads_read", "ads_management"],
    documentationUrl: "https://developers.facebook.com/docs/marketing-apis/",
    color: "#F7941D",
  },
  {
    type: "google_ads",
    name: "google_ads",
    displayName: "Google Ads",
    icon: "🔍",
    description: "Connect your Google Ads account to monitor search and display campaigns",
    requiresAuth: true,
    authType: "oauth2",
    // Service account only. A token or OAuth-popup connection stores a refresh
    // token the server never exchanges for Google Ads (no access token, no
    // developer token), so it connected, could not be tested, and failed every
    // sync. A client account under a manager needs the Login Customer ID field.
    connectionMethods: ["service_account"],
    scopes: ["https://www.googleapis.com/auth/adwords"],
    documentationUrl: "https://developers.google.com/google-ads/api/docs/",
    color: "#4667FF",
  },
  {
    type: "tiktok",
    name: "tiktok",
    displayName: "TikTok Ads",
    icon: "🎵",
    description: "Track your TikTok advertising performance and engagement metrics",
    requiresAuth: true,
    authType: "oauth2",
    connectionMethods: ["token", "oauth2"],
    scopes: ["advertiser_info"],
    documentationUrl: "https://ads.tiktok.com/marketing_api/docs",
    color: "#000000",
  },
  {
    type: "line",
    name: "line",
    displayName: "LINE Ads",
    icon: "💬",
    description: "Connect LINE Ads platform using your API credentials",
    requiresAuth: true,
    authType: "api_key",
    documentationUrl: "https://developers.line.biz/en/docs/",
    color: "#06C755",
  },
  {
    type: "google_analytics",
    name: "google_analytics",
    displayName: "Google Analytics",
    icon: "📊",
    description: "Import website analytics and user behavior data",
    requiresAuth: true,
    authType: "oauth2",
    connectionMethods: ["token", "oauth2"],
    scopes: ["https://www.googleapis.com/auth/analytics.readonly"],
    documentationUrl: "https://developers.google.com/analytics/devguides/reporting/data/v1",
    color: "#F57C00",
  },
];
